import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

import s from './copyright.module.css';

const CURRENT_YEAR = new Date().getFullYear();
const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME;
const SITE_URL = import.meta.env.VITE_SITE_URL;

const siteUrl = {
  en: SITE_URL,
  ru: `${SITE_URL}ru`,
  es: `${SITE_URL}es`,
  pt: `${SITE_URL}pt`,
  fa: `${SITE_URL}fa`,
  hi: `${SITE_URL}hi`,
  ar: `${SITE_URL}ar`,
};

function Copyright() {
  const lang = useSelector(appSelectors.language);

  return (
    <p className={s.copyright}>
      © {CURRENT_YEAR}{' '}
      <a href={siteUrl[lang.code]} target="_blank" rel="noopener noreferrer">
        {PROJECT_NAME}
      </a>
    </p>
  );
}

export default Copyright;
